import {
    useContext,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IChartLegendProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    ChartContext
} from "../../context";
import {
    getChartPattern
} from "../../util";
import ChartLegendItem from "../legendItem";

const ChartLegend: FC<IChartLegendProps> = ({
    customLocalize: customLocalizeProp,
    isToggleable: isToggleableProp,
    customTheme: customThemeProp,
    hiddenKeys: hiddenKeysProp,
    position = "bottom",
    items: itemsProp,
    onToggleSeries,
    style,
    ...props
}) => {
    const context = useContext(ChartContext);

    const customTheme = customThemeProp ?? context?.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalizeProp ?? context?.customLocalize);

    const model = context?.modelRef.current;

    const isToggleable = isToggleableProp ?? context?.isLegendToggleable ?? false;

    const hiddenKeys = hiddenKeysProp ?? context?.hiddenKeys ?? [];

    const derivedItems = model?.legendItems ?? model?.seriesKeys.map((key, index) => ({
        colorIndex: context?.config[key]?.colorIndex ?? ((index % 8) + 1) as 1,
        title: context?.config[key]?.title ?? key,
        key
    })) ?? [];

    const items = itemsProp ?? derivedItems;

    const {
        container: containerDynamicStyle
    } = useStyles({
        isToggleable,
        position,
        spaces
    });

    if(!itemsProp && items.length < 2) {
        return null;
    }

    const visibleCount = items.filter((item) => !hiddenKeys.includes(item.key)).length;

    return <View
        {...props}
        accessibilityLabel={props.accessibilityLabel ?? localize("chart-series")}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        role="group"
    >
        {
            items.map((item) => {
                const isOn = !hiddenKeys.includes(item.key);

                return <ChartLegendItem
                    shape={model?.kind === "line" ? "line" : "square"}
                    onToggle={onToggleSeries ?? context?.toggleSeries}
                    pattern={getChartPattern({
                        isPatterned: context?.isPatterned ?? false,
                        colorIndex: item.colorIndex
                    })}
                    isLocked={isOn && visibleCount === 1}
                    isToggleable={isToggleable}
                    customTheme={customTheme}
                    key={item.key}
                    isOn={isOn}
                    item={item}
                />;
            })
        }
    </View>;
};
export default ChartLegend;
